module.exports = __webpack_public_path__ + "img/d3.55bd3663.png";